import React from 'react';
import { FiBarChart2, FiUser, FiPlus, FiList} from 'react-icons/fi';
import { FaWhatsapp, FaChartLine, FaChartPie} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import logo from '../../../assests/logo.png';
import './styles.css';

export default function Header() {
  function abreMenu(){
    if(document.getElementById("mnu").style.display === 'block'){
      document.getElementById("mnu").style.display = "none"; 
    }else{
      document.getElementById("mnu").style.display = "block";
    }
  }

  const { t } = useTranslation();
  const name = sessionStorage.getItem('name');
  return (
    <header>
     
      <img src={logo} alt="AGROBRAZIL" />
     
      <span>{t('pages.includes.header.welcome')}<br />{name}</span>
      <Link className="mnu" to="/perfil"><FiUser size={18} color="#103878" /><br />{t('pages.includes.header.profile')}</Link>
      <Link className="mnu" to="/ranking"><FiBarChart2 size={18} color="#103878" /><br />{t('pages.includes.header.ranking')}</Link>
      <Link className="mnu" to="/timeline"><FiList size={18} color="#103878" /><br />{t('pages.includes.header.timeline')}</Link>
      <Link className="mnu" to="/escalas"><FaChartLine size={18} color="#103878" /><br />{t('pages.includes.header.scales')}</Link>
      <Link className="mnu" to="/negociacoes"><FaChartPie size={18} color="#103878" /><br />{t('pages.includes.header.negotiations')}</Link>
      <button type="button" onClick={abreMenu}>
        <FiPlus size={18} color="#fff" />
      </button>
      <div className="mnuSuspenso" id="mnu">
          <ul>
            <li>
              <Link to="/mensagem">{t('pages.includes.header.options.newMessage')}</Link>
            </li>
            <li>
              <Link to="/negocio/cadastrar">{t('pages.includes.header.options.newNegotiation')}</Link>
            </li>
            <li>
              <Link to="/anuncio">{t('pages.includes.header.options.newClassified')}</Link>
            </li>
          </ul>
      </div>
    </header>
  );
}